import Echo from 'laravel-echo';
import tokenUtils from '@/utils/tokens';

window.pusher = require('pusher-js');

window.Echo = new Echo({
    auth: {
        headers: {
            'Accept-Locale': 'uk',
            'Api-Version': 'v1',
            'Country-Id': 242,
            'Content-Type': 'application-json',
            'Authorization': `Bearer ${tokenUtils.getActualToken()}`,
            'Session-Id': localStorage.getItem('session-id'),
        }
    },
    authEndpoint: `${process.env.VUE_APP_ROOT_BROADCASTING}auth`,
    broadcaster: 'pusher',
    key: process.env.VUE_APP_PUSHER_APP_KEY,
    cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER,
    forceTLS: true
});
